import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { PointOfService } from "./PointOfService.model";

export class PreVisit extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  email?: string;

  @Validation({ maxLength: 50 })
  phoneNumber?: string;

  @Validation({ maxLength: 255 })
  fullname?: string;

  fK_Image_Signature?: number;

  signatureDate?: Date;

  fK_Image_Form?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  preVisitId!: number;

  @Validation({ maxLength: 255 })
  company?: string;

  symptoms?: boolean;

  @Validation({ maxLength: 255 })
  requester?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  sendDate?: Date;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignature?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageForm?: FSTREAM_Image;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  GetType(): IEntityMetaData {
    return PreVisit.getMetaData();
  }
}
